import { Component, OnInit } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../shared";
import { AddHSActivationComponent } from "./add-hsactivation/add-hsactivation.component";
import { EditHSActivationComponent } from "./edit-hsactivation/edit-hsactivation.component";
import { EmailHSActivationComponent } from "./email-hsactivation/email-hsactivation.component";
import { DataService_HallSweepActivation } from "./shared/data.service";
import { HSActivationPrintRequest } from "./shared/HSActivationPrintRequest";

@Component({
	selector: "caass-hall-sweep-activation",
	templateUrl: "./hall-sweep-activation.component.html",
	styleUrls: ["./hall-sweep-activation.component.css"],
})
export class HallSweepActivationComponent implements OnInit {
	constructor(
		private sanitizer: DomSanitizer,
		private userService: UserService,
		private HSActivationService: DataService_HallSweepActivation,
		private dialogService: DialogService,
		private confirmationService: ConfirmationService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.loadHSActivation();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	Processing: any = false;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedHSActivation: any;
	lstHSActivation: any = [];

	//Filter lists
	lstActiveDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "ActivationCodeShort", header: "Description" },
		{ field: "AvailableCount", header: "Activations Left" },
		{ field: "TotalCount", header: "Total Issued" },
		{ field: "IssueDateDesc", header: "Issue Date" },
		{ field: "ExpireDateDesc", header: "Expire Date" },
		// { field: 'ActiveDesc', header: 'Active' },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadHSActivation() {
		this.loading = true;

		var result = this.HSActivationService.HSActivationSelectList();
		result.subscribe(
			(response) => {
				this.lstHSActivation = response;

				for (var z = 0; z < this.lstHSActivation.length; z++) {
					var next = this.lstHSActivation[z];

					next.PhotoData = this.sanitizer.bypassSecurityTrustResourceUrl(next.QRCode);
				}

				//Load Data Filter Lists
				this.lstActiveDesc = Array.from(new Set(this.lstHSActivation.map((item: any) => item.ActiveDesc)));

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadHSActivation();
	}

	//Custom Button Methods
	onAdd() {
		this.errorMessage = "";

		var ref = this.dialogService.open(AddHSActivationComponent, {
			header: "Add Activation Code",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadHSActivation();
			}
		});
	}

	onEdit() {
		this.errorMessage = "";

		if (this.SelectedHSActivation == undefined) {
			this.errorMessage = "Select an activation code to edit";
			return;
		}

		var ref = this.dialogService.open(EditHSActivationComponent, {
			header: "Edit Activation Code",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				ActivationID: this.SelectedHSActivation.ActivationID,
				ActivationCode: this.SelectedHSActivation.ActivationCode,
				ActivationCodeShort: this.SelectedHSActivation.ActivationCodeShort,
				AvailableCount: this.SelectedHSActivation.AvailableCount,
				TotalCount: this.SelectedHSActivation.TotalCount,
				// IssueDate: this.SelectedHSActivation.IssueDate,
				IssueDateDesc: this.SelectedHSActivation.IssueDateDesc,
				ExpireDate: this.SelectedHSActivation.ExpireDate,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadHSActivation();
			}
		});
	}

	onPrint() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedHSActivation == undefined) {
			this.errorMessage = "Select an activation code to print";
			return;
		}

		//Call SP
		this.Processing = true;

		//Create Request
		let parms: HSActivationPrintRequest = {
			QRTextRaw: this.SelectedHSActivation.QRTextRaw,
		};

		var result = this.HSActivationService.HSActivationPrint(parms);
		result.subscribe(
			(response) => {
				var a = document.createElement("a"); //Create <a>
				a.href = response[0];
				a.download = "QRCode_" + this.SelectedHSActivation.ActivationCode;
				a.click(); //Downloaded file

				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onEmail() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedHSActivation == undefined) {
			this.errorMessage = "Select an activation code to email";
			return;
		}

		if (this.SelectedHSActivation.Active == 0) {
			this.confirmationService.confirm({
				key: "main",
				acceptLabel: "Yes",
				rejectLabel: "No",
				rejectVisible: true,
				message:
					"Activation code is inactive and can't be used to register users unless the expiration date changes or more licenses are purchased. Are you sure you want to email it?",
				header: "Activation Code Inactive",
				icon: "fa",
				accept: () => {
					this.FinishOpenEmailDialog();
				},
				reject: () => {
					return;
				},
			});
		} else {
			this.FinishOpenEmailDialog();
		}
	}

	FinishOpenEmailDialog() {
		//Call SP
		var ref = this.dialogService.open(EmailHSActivationComponent, {
			header: "Email Activation Code",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				QRCode: this.SelectedHSActivation.QRCode,
				// QRTextRaw: this.SelectedHSActivation.QRTextRaw,
				ExpireDateDesc: String(this.SelectedHSActivation.ExpireDateDesc),
				ActivationCode: this.SelectedHSActivation.ActivationCode,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
			}
		});
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedHSActivation = val.data;
	}
	onRowUnselect(val) {
		this.SelectedHSActivation = null;
	}
	onRowDblClick(HSActivation) {
		this.SelectedHSActivation = HSActivation;
		this.onEmail();
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	IsLoading() {
		return this.loading == true || this.Processing == true;
	}

	IsSU() {
		if (this.user == undefined) {
			return false;
		} else {
			return this.user.userID == 0;
		}
	}

	////////////////////////////////////////////
}
